import "shared/extensions/string";

import { ClientLogo } from "shared/UI/ClientLogo/ClientLogo";
import StylableButton from "shared/UI/Buttons/StylableButton";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import { isChangeOrganisation } from "../../Login";
import { EventNames } from "core/monitoring/types/enums";

export type AccessDecisionProps = {
  clientLogo?: string;
  clientName: string;
  clientCode: string;
  handleRedirect: Function;
  handleReset: Function;
};

export const AccessDecision = ({ clientLogo, clientName, clientCode, handleReset, handleRedirect }: AccessDecisionProps) => {
  const { t } = useTranslation();
  const location = useLocation();

  const signInButton = (text: string, event?: string) => (
    <StylableButton
      className="bright-button"
      fullWidth
      color="primary"
      text={text}
      aria-label={t("auth.loginButtonAriaLabel", { clientName })}
      onClick={() => handleRedirect("sign-in", event)}
    />
  );

  return (
    <div className="flex flex-col gap-4">
      <h2 className="text-center text-2xl" aria-hidden>
        {clientName}
      </h2>

      <ClientLogo clientCode={clientCode} imageFilename={clientLogo} alt={t("auth.logo", { clientName })} className="mb-3" />
      {isChangeOrganisation(location) ? (
        <>
          {signInButton("Confirm", EventNames.CONFIRM_CHANGE_ORGANISATION)}
          <button onClick={() => handleReset()} className="w-full h-[3rem] text-lg px-3 py-1.5 bg-transparent border-none">
            Back
          </button>
        </>
      ) : (
        <>
          {signInButton(t("auth.loginButtonLabel"))}
          <StylableButton
            fullWidth
            color="primary"
            className="navy-button bright-button"
            text={t("auth.signupButtonLabel")}
            aria-label={t("auth.signupButtonAriaLabel", { clientName })}
            onClick={() => handleRedirect("sign-up")}
          />
          <div className="text-center mt-5">
            <p role="note">{t("auth.organisationQuestion")}</p>
            <button className="m-2 text-brand font-bold text-[14pt]" role="link" onClick={() => handleReset()}>
              {t("auth.changeOrganisationLink")}
            </button>
          </div>
        </>
      )}
    </div>
  );
};
